import React,{ useEffect } from "react";
import { connect } from "react-redux";
import AssignedAssetsTable from "./components/AssignedAssetsTable";

const AssignedAssets = ({employeeId}) => {

	useEffect(() => {
	}, [employeeId]);
	
	return (
	    <div>
			<div className="grid h-full grid-cols-1 gap-4">
				<AssignedAssetsTable employeeId={employeeId} />
			</div>
	    </div>
    );
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(AssignedAssets);